
import { Component, Vue } from "vue-property-decorator";
import { UserService } from "src/services";
import { Toast } from "vant";
import patterns from "src/utils/patterns";
import globalConfig from "src/config/index";
import { markPasswordChanged } from "src/utils/employer-session";

Component.registerHooks(["beforeRouteEnter"]);

@Component
export default class UpdatePwd extends Vue
{
    private loading: boolean = false;
    private returnByHistory: boolean = false;

    private beforeRouteEnter(to: any, from: any, next: any): void
    {
        next((vm: UpdatePwd) => {
            vm.returnByHistory = from.name === "perfect-user";
        });
    }

    private get isPerfectFlow(): boolean
    {
        return this.$route.query.from === "perfect-user";
    }

    private validatorNewPassword(val: string): boolean
    {
        return val !== this.modelData.oldPassword;
    }
    /**
     * 修改数据模型
     * @private
     * @returns string
     */
    private modelData: any =
    {
        oldPassword: "",
        password: "",
        confirm: ""
    };

    /**
     * 密码显示方式集合
     * @private
     * @returns string
     */
    private state: any =
    {
        showOldPassword: "",
        showPassword: "",
        showConfirm: ""
    };

    /**
     * 获取当前登入信息
     * @private
     * @returns void
     */
    private get userInfo(): any
    {
        return this.$store.getters.userInfo || {};
    }

    /**
     * 获取当前登入机构信息
     * @private
     * @returns void
     */
    private get orgInfo(): any
    {
        return this.$store.getters.orgInfo || {};
    }

    /**
     * 验证两次密码是否一直
     * @private
     * 
     * @returns void
     */
    private validatorPwd(val: any): any
    {
        return this.modelData.password === val;
    }

    /**
     * 验证密码长度
     * @private
     * @returns void
     */
    private validatorpwdLength(val: any): any
    {
        return val.length >= 6 && val.length <= 32;
    }

    /**
     * 获取当前登入企业相关配置
     * @private
     * @returns void
     */
     protected get employerConfig(): any
    {
        let appid = localStorage.getItem("appid");

        let employerConfig = globalConfig.employerConfig[appid];

        return employerConfig;
    }

    /**
     * 保存
     * @private
     * @returns void
     */
    private async onSave(): Promise<void>
    {
        if (this.loading) return;
        if (!this.validatorNewPassword(this.modelData.password)) {
            Toast("新密码不能与旧密码相同");
            return;
        }
        const appid = localStorage.getItem("appid") || "";
        const userId = this.userInfo.userId;
        this.loading = true;
        try
        {
            let {content: result} =  await UserService.instance.updatePwd(this.modelData);
            markPasswordChanged(appid, userId);
            if (this.isPerfectFlow) {
                // 当前接口不会注销 JWT，完善资料流程继续使用当前登录和资料草稿。
                localStorage.removeItem("loginData");
                Toast("密码修改成功，请继续完善个人信息");
                if (this.returnByHistory) {
                    this.$router.go(-1);
                } else {
                    // 从首页提示进入或刷新改密页时，不依赖上一个历史页面。
                    this.$router.replace({ name: "perfect-user", query: { userId } });
                }
                return;
            }
            Toast("修改密码成功，请重新登录");
            window.localStorage.clear();
            localStorage.setItem("appid", appid);
            this.$store.dispatch("setUserInfo", null);
            localStorage.removeItem("userInfo");
            this.$router.push({name: "login"});
        }
        catch(err)
        {
            Toast(err);
        }
        finally
        {
            this.loading = false;
        }
    }
}
